import React from 'react'
import PropTypes from 'prop-types'
import {camelize} from 'humps'
import {useTranslation} from 'react-i18next'
import {uniqBy} from 'lodash-es'
import {ListItem, Text, UnorderedList} from '@chakra-ui/react'

const PendingReasons = ({pendingReasonKeys}) => {
  const {t} = useTranslation('onboarding')

  const translate = (key) =>
    t(
      `onboarding:acquisitionDecisionPendingReasons.${camelize(key)}`,
      t('onboarding:acquisitionDecisionPendingReasons.default'),
    )

  const pendingReasons = pendingReasonKeys.reduce(
    (memo, key) =>
      uniqBy(memo.concat({key, value: translate(key)}), ({value}) => value),
    [],
  )

  return (
    <UnorderedList pb="sm">
      {pendingReasons.map((reason) => (
        <ListItem key={reason.key}>
          <Text>{reason.value}</Text>
        </ListItem>
      ))}
    </UnorderedList>
  )
}

PendingReasons.propTypes = {
  pendingReasonKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default PendingReasons
